import isEmpty from 'ramda/src/isEmpty'
import botModule from '@/store/modules/bot.module'
import marketModule from '@/store/modules/market.module'
import marketService from '@/services/amio/market.service'

// Standalone pages (e.g. Variables, Email Template) need bot/market lists for
// selectors and multimarket labels, which are otherwise only loaded on Bots settings.
// Market failures stay silent unless the caller opts in, so pages that label bots
// by market can report the error themselves.
export async function ensureBotAndMarketLists(silent = true) {
  const failedLists = []

  try {
    if (isEmpty(botModule.getBotList())) await botModule.setBotList()
  } catch (err) {
    failedLists.push('bots')
  }

  try {
    if (isEmpty(marketModule.getMarketList())) {
      marketModule.setMarketList(await marketService.list())
    }
  } catch (err) {
    failedLists.push('markets')
  }

  if (silent || !failedLists.length) return

  const error = new Error(`Failed to load ${failedLists.join(' and ')}`)
  error.failedLists = failedLists
  throw error
}
